import type { CategoryChild } from "../types/filters.type";

export type ChipItem = {
  field: string;
  value: string;
  label: string;
};

type CategoryNodeLike = {
  id: string | null;
  label: string;
  children?: CategoryChild[];
};

export function findCategoryLabel(
  node: CategoryNodeLike,
  id: string,
): string | null {
  if (node.id === id) return node.label;
  for (const child of node.children ?? []) {
    const found = findCategoryLabel(child, id);
    if (found) return found;
  }
  return null;
}

export function formatPriceLabel(
  min: number,
  max: number,
  currency: string,
  locale: string,
): string {
  const fmt = new Intl.NumberFormat(locale, { style: "currency", currency });
  return `${fmt.format(min)} - ${fmt.format(max)}`.replace(/ /g, " ");
}
